/**
 * Converts a collection into an object. The keys of the resulting object are set using as value the indexProp pass in.
 * @param list A collection to be converted into a map
 * @param indexProp The property name of a unique value in the input list elements. This value is used as key in the resulting map.
 * @constructor
 */
export const createMapFromList = <T extends object>(list: Array<T>, indexProp: keyof T) => {
    const indexedList: { [key: string]: T[] } = {};

    if (!list || list.length === 0) {
        return indexedList;
    }

    list.forEach((element) => {
        const key = element[indexProp] as unknown as string;

        if (indexedList[key]) {
            indexedList[key].push(element);
        } else {
            indexedList[key] = [element];
        }
    });

    return indexedList;
};
